module.exports = __webpack_public_path__ + "lighthouse-logo.png";


//////////////////
// WEBPACK FOOTER
// ./images/integrations/lighthouse-logo.png
// module id = 1260
// module chunks = 74